import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  PRODUCT_RESULT_OPTIONS,
  ProductResult,
} from '@/pages/instruments/new-instrument/constants/products-results'

export interface ProductResultFormFieldProps {}

export const ProductResultFormField: React.FC<ProductResultFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ product_result: ProductResult }>()
  return (
    <FormField
      name="product_result"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Product Result</FormLabel>
              <FormError />
            </div>
            <SelectInput
              className={'w-full'}
              placeholder={'Product Result'}
              value={value}
              onValueChange={(value) =>
                setValue('product_result', value as ProductResult, { shouldValidate: true })
              }
              options={PRODUCT_RESULT_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
